document.addEventListener('DOMContentLoaded', function () {

  // Mobiles Menü
  var toggle = document.querySelector('.mobile-nav-toggle');
  var nav = document.querySelector('.main-nav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('is-open');
    });
  }

  // Produktbild-Thumbnails
  document.querySelectorAll('.product-thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mainImg = document.getElementById('ProductMainImage');
      if (mainImg) mainImg.src = btn.getAttribute('data-image-url');
    });
  });

  // Kategorie-Karussell: Scroll-Pfeile
  document.querySelectorAll('.category-carousel').forEach(function (carousel) {
    var track = carousel.querySelector('[data-category-track]');
    if (!track) return;
    carousel.querySelectorAll('[data-category-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var amount = track.clientWidth * 0.8;
        var direction = btn.getAttribute('data-category-scroll') === 'prev' ? -1 : 1;
        track.scrollBy({ left: amount * direction, behavior: 'smooth' });
      });
    });
  });

  // Variantenauswahl: passende Variante ermitteln und Preis/Verfügbarkeit aktualisieren
  document.querySelectorAll('form[action^="/cart/add"]').forEach(function (form) {
    var productSection = form.closest('.product');
    if (!productSection) return;

    var jsonEl = productSection.querySelector('script[id^="ProductJson-"]');
    if (!jsonEl) return;

    var productData;
    try {
      productData = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var optionSelects = form.querySelectorAll('.product-option select');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = productSection.querySelector('.price-current');
    var addBtn = form.querySelector('.btn-add-to-cart');

    function updateVariant() {
      var selectedOptions = Array.from(optionSelects).map(function (s) { return s.value; });

      var match = productData.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return selectedOptions.length === 0 || opt === selectedOptions[i];
        });
      });

      if (match) {
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = match.price;
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? addBtn.dataset.label : 'Ausverkauft';
        }
      }
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', updateVariant);
    });
  });

});
/* Unterkategorie-Leiste im Header: Klick auf eine Kategorie-Karte mit Unterpunkten */
(function () {
  function getWrapper() {
    return document.querySelector('[data-sub-panels]');
  }

  function sizePanels() {
    var wrapper = getWrapper();
    var tile = document.querySelector('.header-categories .category-card');
    if (!wrapper || !tile) return;
    var pct = parseFloat(wrapper.getAttribute('data-sub-height-percent')) || 50;
    wrapper.style.setProperty('--subtile-height', Math.round(tile.offsetHeight * pct / 100) + 'px');
  }

  function closeAll() {
    var wrapper = getWrapper();
    if (!wrapper) return;
    wrapper.hidden = true;
    wrapper.querySelectorAll('[data-sub-panel]').forEach(function (p) { p.hidden = true; });
    document.querySelectorAll('[data-sub-target]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      t.classList.remove('is-active');
    });
  }

  document.addEventListener('click', function (event) {
    var tile = event.target.closest('[data-sub-target]');
    if (!tile) return;
    var wrapper = getWrapper();
    if (!wrapper) return;
    var panel = wrapper.querySelector('[data-sub-panel="' + tile.getAttribute('data-sub-target') + '"]');
    if (!panel) return;

    event.preventDefault();
    var wasOpen = !panel.hidden;
    closeAll();
    if (!wasOpen) {
      sizePanels();
      wrapper.hidden = false;
      panel.hidden = false;
      tile.setAttribute('aria-expanded', 'true');
      tile.classList.add('is-active');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAll();
  });

  window.addEventListener('resize', sizePanels);
})();